import { render, staticRenderFns } from "./CompanyOrders.vue?vue&type=template&id=daf05a8c"
import script from "./CompanyOrders.vue?vue&type=script&lang=js"
export * from "./CompanyOrders.vue?vue&type=script&lang=js"
import style0 from "./CompanyOrders.vue?vue&type=style&index=0&id=daf05a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports